import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { HomeIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { toast } from 'react-toastify';

const PreventivatorePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [offerta, setOfferta] = useState(null);
  const [tipoCliente, setTipoCliente] = useState('');
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    nome: '',
    cognome: '',
    email: '',
    telefono: '',
    ragioneSociale: '',
    partitaIva: '',
    codiceFiscale: '',
    note: ''
  });

  // Carica i dati dell'offerta selezionata
  useEffect(() => {
    // Controlla se abbiamo l'offerta nei parametri di navigazione
    if (location.state?.offertaSelezionata) {
      setOfferta(location.state.offertaSelezionata);
      setTipoCliente(location.state.tipoCliente || 'Privato');
      setLoading(false);
    } else {
      // Altrimenti controlla se c'è in localStorage
      const savedOfferta = localStorage.getItem('offertaSelezionata');
      if (savedOfferta) {
        try {
          const parsedOfferta = JSON.parse(savedOfferta);
          setOfferta(parsedOfferta);
          setTipoCliente(location.state?.tipoCliente || 'Privato');
          setLoading(false);
        } catch (error) {
          console.error('Errore nel parsing dell\'offerta salvata:', error);
          setLoading(false);
        }
      } else {
        // Se non c'è l'offerta, torna alla pagina delle offerte
        toast.warning('Nessuna offerta selezionata. Verrai reindirizzato alla pagina delle offerte.');
        navigate('/nlt/offerte-vetture-lt');
      }
    }
  }, [location, navigate]);

  // Gestione del form
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Invia il preventivo
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!offerta) {
      toast.error('Dati offerta non disponibili.');
      return;
    }
    
    try {
      // Dati del preventivo
      const preventivoData = {
        ...formData,
        tipoCliente,
        idVettura: offerta.vettura?.id,
        idOfferteVetture: offerta.id,
        durata: offerta.durata,
        kmAnnui: offerta.kmAnnui,
        anticipo: offerta.anticipo || 0,
        canone: offerta.canone,
        provvigione: offerta.provvigione || 0, // Campo provvigione nascosto
        statoDisponibilita: offerta.statoDisponibilita || 'Ordine',
        penaleKasko: offerta.penaleKasko,
        penaleRCA: offerta.penaleRCA,
        penaleFurto: offerta.penaleFurto,
        servizi: offerta.servizi
      };
      
      // Chiamata API per salvare il preventivo
      const response = await api.post('/quotations', preventivoData);
      
      if (response.data) {
        toast.success('Preventivo inviato con successo!');
        // Pulisci il localStorage
        localStorage.removeItem('offertaSelezionata');
        // Reindirizza alla pagina delle quotazioni o alla dashboard
        navigate('/nlt/');
      }
    } catch (error) {
      console.error('Errore nell\'invio del preventivo:', error);
      toast.error('Errore nell\'invio del preventivo. Riprova più tardi.');
    }
  };

  // Formatta prezzo
  const formatPrezzo = (prezzo) => {
    if (prezzo === undefined || prezzo === null) return '0 €';
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(prezzo);
  };

  // Formattazione penali
  const formatPenaleValue = (value) => {
    if (!value || value === 0) return 'Nessuna';
    
    // Se è un valore negativo, è una percentuale
    if (value < 0) {
      return `${Math.abs(value)}%`;
    }
    
    // Altrimenti è un valore in euro
    return `${value}€`;
  };

  // Interpreta i servizi JSON
  const getServiziSelezionati = (serviziString) => {
    if (!serviziString) return [];
    try {
      return JSON.parse(serviziString);
    } catch (error) {
      console.error('Errore nel parsing dei servizi:', error);
      return [];
    }
  };

  if (loading) {
    return (
      <div className="p-6 flex justify-center">
        <div className="spinner">Caricamento...</div>
      </div>
    );
  }

  if (!offerta) {
    return (
      <div className="p-6">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          <p>Nessuna offerta selezionata.</p>
          <button
            onClick={() => navigate('/nlt/offerte-vetture-lt')}
            className="mt-2 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
          >
            Torna alle offerte
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      {/* Breadcrumb */}
      <nav className="flex mb-6" aria-label="Breadcrumb">
        <ol className="flex space-x-4 items-center">
          <li>
            <div>
              <Link to="/nlt/" className="text-gray-400 hover:text-gray-500">
                <HomeIcon className="flex-shrink-0 h-5 w-5" aria-hidden="true" />
                <span className="sr-only">Home</span>
              </Link>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <ChevronRightIcon
                className="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              <Link
                to="/nlt/offerte-vetture-lt"
                className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              >
                Offerte Noleggio LT
              </Link>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <ChevronRightIcon
                className="flex-shrink-0 h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
              <span className="ml-4 text-sm font-medium text-gray-500">
                Preventivatore
              </span>
            </div>
          </li>
        </ol>
      </nav>

      <div className="max-w-7xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Richiedi un preventivo</h1>
        
        <div className="bg-white shadow overflow-hidden sm:rounded-lg mb-8">
          <div className="px-4 py-5 sm:px-6 bg-blue-50">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Dati del veicolo e dell'offerta selezionata
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Verifica i dettagli prima di procedere con la richiesta.
            </p>
          </div>
          
          <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div>
                <h4 className="text-sm font-medium text-gray-500">Vettura</h4>
                <p className="mt-1 text-lg font-semibold">
                  {offerta.vettura?.marca?.descrizione || ''} {offerta.vettura?.modello || ''} {offerta.vettura?.allestimento || ''}
                </p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Canone Mensile</h4>
                <p className="mt-1 text-lg font-semibold text-blue-600">
                  {formatPrezzo(offerta.canone)} <span className="text-sm font-normal">IVA escl.</span>
                </p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Anticipo</h4>
                <p className="mt-1 text-lg font-semibold">
                  {formatPrezzo(offerta.anticipo || 0)} <span className="text-sm font-normal">IVA escl.</span>
                </p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Durata</h4>
                <p className="mt-1 text-lg font-semibold">{offerta.durata} mesi</p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Chilometraggio Annuo</h4>
                <p className="mt-1 text-lg font-semibold">{parseInt(offerta.kmAnnui).toLocaleString()} km</p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Società di Noleggio</h4>
                <p className="mt-1 text-lg font-semibold">{offerta.societaNoleggio?.nome || '-'}</p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Penale Kasko</h4>
                <p className="mt-1 text-lg font-semibold">{formatPenaleValue(offerta.penaleKasko)}</p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Penale RCA</h4>
                <p className="mt-1 text-lg font-semibold">{formatPenaleValue(offerta.penaleRCA)}</p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Penale Furto/Incendio</h4>
                <p className="mt-1 text-lg font-semibold">{formatPenaleValue(offerta.penaleFurto)}</p>
              </div>
              
              <div>
                <h4 className="text-sm font-medium text-gray-500">Stato Disponibilità</h4>
                <p className="mt-1 text-lg font-semibold">{offerta.statoDisponibilita || 'Ordine'}</p>
              </div>
              
              {/* Campo provvigione nascosto per il backend */}
              <input type="hidden" name="provvigione" value={offerta.provvigione || 0} />
            </div>
            
            {/* Servizi inclusi */}
            <div className="mt-6">
              <h4 className="text-sm font-medium text-gray-500 mb-2">Servizi inclusi</h4>
              {getServiziSelezionati(offerta.servizi).length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
                  {getServiziSelezionati(offerta.servizi).map((servizio, index) => (
                    <div key={index} className="flex items-center">
                      <svg className="h-5 w-5 text-green-500 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>{servizio}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-gray-500">Nessun servizio aggiuntivo incluso</p>
              )}
            </div>
          </div>
        </div>
        
        {/* Form di richiesta */}
        <div className="bg-white shadow overflow-hidden sm:rounded-lg">
          <div className="px-4 py-5 sm:px-6 bg-blue-50">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              Dati di contatto
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Compila il modulo per richiedere informazioni o un preventivo personalizzato.
            </p>
          </div>
          
          <div className="border-t border-gray-200 px-4 py-5 sm:p-6">
            <form onSubmit={handleSubmit}>
              {/* Selezione tipo cliente */}
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Tipo Cliente
                </label>
                <div className="mt-1">
                  <select
                    disabled={true}
                    className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md bg-gray-100"
                    value={tipoCliente}
                  >
                    <option value="Privato">Privato</option>
                    <option value="Azienda">Azienda</option>
                    <option value="Tutti">Tutti</option>
                  </select>
                  <p className="mt-1 text-xs text-gray-500">Tipo cliente ereditato dalla selezione offerta</p>
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Campi per tutti i tipi di cliente */}
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-gray-700">
                    Nome *
                  </label>
                  <input
                    type="text"
                    name="nome"
                    id="nome"
                    required
                    value={formData.nome}
                    onChange={handleChange}
                    className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
                
                <div>
                  <label htmlFor="cognome" className="block text-sm font-medium text-gray-700">
                    Cognome *
                  </label>
                  <input
                    type="text"
                    name="cognome"
                    id="cognome"
                    required
                    value={formData.cognome}
                    onChange={handleChange}
                    className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
                
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email *
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
                
                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-gray-700">
                    Telefono *
                  </label>
                  <input
                    type="tel"
                    name="telefono"
                    id="telefono"
                    required
                    value={formData.telefono}
                    onChange={handleChange}
                    className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  />
                </div>
                
                {/* Campi specifici per Azienda */}
                {(tipoCliente === 'Azienda' || tipoCliente === 'Tutti') && (
                  <>
                    <div>
                      <label htmlFor="ragioneSociale" className="block text-sm font-medium text-gray-700">
                        Ragione Sociale {tipoCliente === 'Azienda' ? '*' : ''}
                      </label>
                      <input
                        type="text"
                        name="ragioneSociale"
                        id="ragioneSociale"
                        required={tipoCliente === 'Azienda'}
                        value={formData.ragioneSociale}
                        onChange={handleChange}
                        className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                    
                    <div>
                      <label htmlFor="partitaIva" className="block text-sm font-medium text-gray-700">
                        Partita IVA {tipoCliente === 'Azienda' ? '*' : ''}
                      </label>
                      <input
                        type="text"
                        name="partitaIva"
                        id="partitaIva"
                        required={tipoCliente === 'Azienda'}
                        value={formData.partitaIva}
                        onChange={handleChange}
                        className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      />
                    </div>
                  </>
                )}
                
                {/* Campi specifici per Privato */}
                {(tipoCliente === 'Privato' || tipoCliente === 'Tutti') && (
                  <div>
                    <label htmlFor="codiceFiscale" className="block text-sm font-medium text-gray-700">
                      Codice Fiscale {tipoCliente === 'Privato' ? '*' : ''}
                    </label>
                    <input
                      type="text"
                      name="codiceFiscale"
                      id="codiceFiscale"
                      required={tipoCliente === 'Privato'}
                      value={formData.codiceFiscale}
                      onChange={handleChange}
                      className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                    />
                  </div>
                )}
              </div>
              
              {/* Note */}
              <div className="mt-6">
                <label htmlFor="note" className="block text-sm font-medium text-gray-700">
                  Note aggiuntive
                </label>
                <textarea
                  id="note"
                  name="note"
                  rows="4"
                  value={formData.note}
                  onChange={handleChange}
                  className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                  placeholder="Inserisci qui eventuali richieste o informazioni aggiuntive"
                />
              </div>
              
              {/* Privacy */}
              <div className="mt-6">
                <div className="flex items-start">
                  <div className="flex items-center h-5">
                    <input
                      id="privacy"
                      name="privacy"
                      type="checkbox"
                      required
                      className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label htmlFor="privacy" className="font-medium text-gray-700">
                      Accetto la privacy policy
                    </label>
                    <p className="text-gray-500">
                      Acconsento al trattamento dei dati personali per l'elaborazione della richiesta.
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Bottoni */}
              <div className="mt-8 flex justify-end">
                <button
                  type="button"
                  onClick={() => navigate('/nlt/offerte-vetture-lt')}
                  className="mr-3 inline-flex justify-center py-2 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Annulla
                </button>
                <button
                  type="submit"
                  className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Invia richiesta
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreventivatorePage; 